import * as Yup from 'yup';

export const clientSupervisionSchema = Yup.object().shape({
  client_id: Yup.number().required(),
  utc_offset: Yup.number(),
  date_start: Yup.string().required(),
  duration: Yup.number().required(),
  location: Yup.string().required(),
  setting: Yup.string().required(),
  participants: Yup.object({
    parent: Yup.boolean(),
    sibling: Yup.boolean(),
  }),
  participants_names: Yup.string().notRequired().nullable(),
  bt_participants: Yup.object({
    primary: Yup.object().nullable().notRequired(),
    secondary: Yup.array().of(Yup.object()).nullable(),
  }).required(),
});

export const targetPhaseSchema = Yup.object().shape({
  target_id: Yup.number().required(),
  title: Yup.string().required(),
  date_added: Yup.string().required(),
});
